import {
  FileTextOutlined,
  BarChartOutlined,
  LineChartOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import { Card, Col, Row, Typography, Skeleton } from "antd";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;

const MetricsCards = ({ metrics, loading }) => {
  const { t } = useTranslation();

  const metricsData = [
    {
      key: "totalAnswers",
      title: t("Reports.TotalAnswers"),
      getDescription: (v) => t('Reports.TotalAnswersDescription', { v }),
      icon: FileTextOutlined,
      color: "#4085c6",
      value: metrics.totalAnswers,
    },
    {
      key: "uniqueForms",
      title: t("Reports.UniqueForms"),
      getDescription: (v) => t('Reports.UniqueFormsDescription', { v }),
      icon: BarChartOutlined,
      color: "#34d399",
      value: metrics.uniqueForms,
    },
    {
      key: "avgAnswers",
      title: t("Reports.AvgAnswers"),
      getDescription: (v) => t('Reports.AvgAnswersDescription', { v }),
      icon: LineChartOutlined,
      color: "#60a5fa",
      value: metrics.avgAnswersPerForm,
    },
    {
      key: "topForm",
      title: t("Reports.TopForm"),
      getDescription: (v) => metrics.topForm 
        ? t('Reports.TopFormDescription', { formName: metrics.topForm.formName, answerCount: metrics.topForm.answerCount })
        : t("Reports.NoData"),
      icon: TrophyOutlined,
      color: "#f87171",
      value: metrics.topForm?.answerCount || 0,
    },
  ];


  if (loading) {
    return (
      <Row gutter={[8, 8]} wrap align="stretch" style={{ marginBottom: 20 }}>
        {[1, 2, 3, 4].map((i) => (
          <Col xs={24} sm={12} md={8} lg={8} xl={6} key={i} style={{ height: "100%" }}>
            <Card style={{ height: "100%", minHeight: 100 }}>
              <Skeleton active />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <Fragment>
      <Row gutter={[8, 8]} wrap align="stretch" style={{ marginBottom: 20 }}>
        {metricsData.map((metric, idx) => {
          const Icon = metric.icon;
          const count = metric.value ?? 0;

          return (
            <Col xs={24} sm={12} md={8} lg={8} xl={6} key={idx} style={{ height: "100%" }}>
              <Card
                style={{
                  height: "100%",
                  minHeight: 100,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <Icon style={{ fontSize: 28, color: metric.color, marginRight: 12 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <Title
                      level={5}
                      style={{
                        marginBottom: 4,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {metric.title}
                    </Title>
                    <Text
                      type="secondary"
                      style={{
                        fontSize: 14,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {metric.getDescription(count)}
                    </Text>
                  </div>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Fragment>
  );
};

export default MetricsCards;